import Backbone from 'backbone';
import ko from 'knockout';
import { filter, difference, contains } from 'underscore';
import tmpl from '@bingads-webui-campaign-legacy/auto-targets/template/create/exactURLs.pug';
import ViewModel from '@bingads-webui-campaign-legacy/auto-targets/viewmodel/create/exactURLs';
import { isValidUrl } from '@bingads-webui/url-util';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

const isValidUrlWithComma = (url) => {
  if (contains(url, ',')) {
    return isValidUrl(url.replace(',', ''));
  }
  return isValidUrl(url);
};

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = options;

    this.viewmodel = new ViewModel(this.options);
  }

  get events() {
    return {
      'click .addall-button': 'selectTarget',
    };
  }

  render() {
    this.$el.html(tmpl({
      i18n,
      containerTitle: this.options.isExclude ? i18n.get('DSA_Target_ExactURLs_Container_Title_Exclude') : i18n.get('DSA_Target_ExactURLs_Container_Title'),
    }));
    ko.applyBindings(this.viewmodel, this.el);
    return this;
  }

  show() {
    this.$el.show();
    return this;
  }

  hide() {
    this.$el.hide();
    return this;
  }

  selectTarget() {

    let validUrls = filter(this.viewmodel.values(), this.validate);

    // Get invalid urls and filter out empty url
    let invalidUrls = difference(this.viewmodel.values(), validUrls).map((condition) => condition.ArgumentOperand).filter((url) => url);

    this.viewmodel.hasError(invalidUrls.length !== 0);

    if (invalidUrls) {
      this.viewmodel.urls(invalidUrls.join('\r\n'));
    }  else {
      this.viewmodel.reset();
    }

    this.trigger('selectTarget', {
      conditions: validUrls,
      type: 'exacturls',
      shouldCheckArgumentOperandFormat: this.options.shouldCheckArgumentOperandFormat,
    });
  }

  reset() {
    this.viewmodel.reset();
  }

  validate(condition) {
    // Auto patch https for valid url
    if (!condition.ArgumentOperand.startsWith('http://') && !condition.ArgumentOperand.startsWith('https://')) {
      const isValid = isValidUrlWithComma(`https://${condition.ArgumentOperand}`);

      if (isValid) {
        condition.ArgumentOperand = `https://${condition.ArgumentOperand}`;
      }
      return isValid;
    } else {
      return isValidUrlWithComma(condition.ArgumentOperand);
    }
  }
}
